import { Button } from "antd";
import "./CustomButton.scss";

const CustomButton = (props: any) => {
  return (
    <Button
      className={props.disabled ? "" : "custom-button"}
      type={props.type}
      danger={props.danger}
      htmlType={props.htmlType}
      onClick={props.function}
      disabled={props.disabled}
    >
      {props.text}
    </Button>
  );
};

export default CustomButton;
